import { useQuery } from '@tanstack/react-query';
import type { Card } from '@/@types/Checkout.type';
import { getPaymentCards } from '@/services/sales.service';

const PAYMENT_CARDS_QUERY_KEY = ['payments', 'cards'] as const;

/** The user's saved cards, and the one a charge uses unless the user picks another. */
export const usePaymentCards = () => {
	const query = useQuery({
		queryKey: PAYMENT_CARDS_QUERY_KEY,
		queryFn: () => getPaymentCards() as Promise<Card[]>,
		staleTime: 60 * 1000,
	});
	const cards = query.data ?? [];
	return { query, cards, defaultCardId: (cards.find((card) => card.is_default) ?? cards[0])?.id ?? null };
};
